





















































import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";

import "./winner-carousel.less";
import {translate} from "@/services/translation/translation";

@Component
export default class winnerCarousel extends Vue {
  @Prop() winnerItems!: String[];
  @Prop() lifeDetailsUrl!: string;

  private showCarousel = false;
  private imgRatio = 2.6666;
  private sortedImages = null;

  mounted() {
    setTimeout(() => {
      if (this.winnerItems.length > 1) {
        this.initCarousel();
      }
      this.setHeight();
      $(window).resize(this.setHeight);
    }, 200);
  }

  updated() {
    this.setHeight();
  }

  loaded(ev) {

    setTimeout(()=>{
      $('.lc-project-slider-arrow').css('top', '0%');
      $('.lc-project-slider-arrow').css('top', '50%');
    }, 550)
    const img = $(ev.target);
    if (img.length) {
      img
        .eq(0)
        .addClass(
          img.get(0).naturalWidth! / img.get(0).naturalHeight! < this.imgRatio
            ? "narrow"
            : "wide"
        );
    }
  }

  private calculateHeight() {
    //@ts-ignore
    const container = $(this.$refs.imageContainer);
    //@ts-ignore
    const width = container.width();
    return (width! / 16) * 9;
  }

  private setHeight() {
    //@ts-ignore
    const container = $(this.$refs.imageContainer);
    //@ts-ignore
    container.height(this.calculateHeight);
    $('.image-container').height(this.calculateHeight);
    setTimeout(()=>{
      $('.lc-project-slider-arrow').css('top', '0%');
      $('.lc-project-slider-arrow').css('top', '50%');
    }, 550)
  }

  private next() {
    //@ts-ignore
    const carousel = $(this.$refs.projectCarousel);
    (carousel as any).slick("slickNext");
  }

  private prev() {
    //@ts-ignore
    const carousel = $(this.$refs.projectCarousel);
    (carousel as any).slick("slickPrev");
  }
  navigate(url) {
    location.href = url;
  }

  initCarousel() {
    setTimeout(() => {
      //@ts-ignore
      const carousel = $(this.$refs.projectCarousel);

      (carousel as any)
        .slick({
          dots: true,
          infinite: true,
          speed: 600,
          autoplay: false,
          arrows: false,
          autoplaySpeed: 7000,
          slidesToShow: 1,
          adaptiveHeight: false
        })
        .on("setPosition", (event, slick) => {
          slick.$slideTrack.height(this.calculateHeight());
        });
    }, 10);
  }


  trans(key) {
    return translate(key);
  }
}
